import React, { Component } from "react"
 import { connect } from "react-redux";
import { ToastContainer, toast } from 'react-toastify';
import { LoginService, logoutUser, ForgotPasswordService, sessionExpireFalseStatus } from "../../services/common/action";
import { getByLocation } from "../../services/patient/action";
 
import "../../assets/css/custom.css";
import Loader from "react-loader-spinner";




import { NavLink } from "react-router-dom";

class Login extends Component {
    constructor(props) {
        super(props)
        this.state = {
            email: "",
            password: "",
            errors: {
                email: "",
                password: ""
            },
            emailValid: false,
            passwordValid: false,
            formValid: false
        };
    }

    handleChange = (e) => {
        e.preventDefault();
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value }, () => {
            this.validateField(name, value);
          });
    };

    componentDidMount() {
         this.props.logoutUser();
        this.props.getByLocation();
      
    }

    validateField(fieldName, value) {
        const { errors, emailValid,   } = this.state;
        let emailvalid = emailValid;

        let fieldValidationErrors = errors;
        switch (fieldName) {
            case "email":
                emailvalid = value.match(
                    /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i
                );
                fieldValidationErrors.email =  emailvalid
                    ? ""
                    : "Please enter valid email address.";
                break;
            
            default:
                break;
        }
        this.setState({ errors: fieldValidationErrors, emailValid: emailvalid,
        })
    }
 

     

    handleLogin = (e) => {
        this.props.sessionExpireFalseStatus();
        e.preventDefault();
        const { password, email } = this.state;
        var details = {
            'username': email,
            'password': password,
            'grant_type': "password"
        };
        var formBody = [];
        for (var property in details) {
            var encodedKey = encodeURIComponent(property);
            var encodedValue = encodeURIComponent(details[property]);
            formBody.push(encodedKey + "=" + encodedValue);
        }
        formBody = formBody.join("&");

        this.props.LoginService(formBody, email)

    }

  


    componentWillReceiveProps = nextProps => {
        toast.dismiss();
            if (nextProps.forgotPasswordStatus) {
              
                this.props.history.push("/CreateNewPassword");
        }
        if(nextProps.sessionExpireStatus){
            toast.error("Session expired please login again")
        }
        if (nextProps.loginStatus === true) {
            if (nextProps.profileDetails) {
               // let data = nextProps.profileDetails.commonUser.registrationStatus
            
                switch (nextProps.profileDetails.commonUser.userType) {

                    case "patient":
                let  accountStatus =  nextProps.profileDetails.commonUser.isEnabled

                        if(accountStatus){
                        this.props.history.push("/PatientHome");
                        }
                        if(!accountStatus){
                            this.props.history.push("/EnableAccount");
                        }
                        // toast.success("Login success");
                        break;
                    case "facility":
                        this.props.history.push("/FacilityHome");
                        break;
                    case "admin":
                        this.props.history.push("/AdminHome");
                        // toast.success("Login success");
                        break;
                    case "employee":
                        this.props.history.push("/EmployeHome");
                        // toast.success("Login success");
                        break;
                    case "other":
                    accountStatus =  nextProps.profileDetails.commonUser.isEnabled

                    if(accountStatus){
                    this.props.history.push("/PatientHome");
                    }
                    if(!accountStatus){
                        this.props.history.push("/EnableAccount");
                    }
                        break;
                    default:
                        break;
                }
            } else {
                toast.error(nextProps.error);
            }
        }
    }
    render() {
          const { isLoading } = this.props;
        const { password, email, errors,  } = this.state;
        let hrefValue = "#"
        return (
            <React.Fragment>
                {isLoading && (
                    <div className="pop-mod">
                        <div className="loder-back">
                            <Loader
                                type="Ball-Triangle"
                                color="#CC6900"
                                height="100"
                                width="100"
                            />
                        </div>
                    </div>
                )}

                <ToastContainer hideProgressBar autoClose={5000} />

                {/* <Header status={"beforeLogin"} /> */}
                <div className="login-wrapper2">
                    <div className="login-sec">
                        <div className="login-box">
                            <form onSubmit={this.handleLogin}>
                                <h1>ePaper Road</h1>
                                <div className="row input-section" >
                                    <div className="form-group pos-relative">
                                        <input type="text" onChange={this.handleChange}
                                            name="email" value={email} placeholder="Email or Mobile " />
                                        <div className="input-icon">
                                            <img src="images/loginmai1l.png" alt="login mail"/>
                                        </div>
                                       

                                    </div>
                                    <div className="form-group pos-relative">
                                        <input type="password" onChange={this.handleChange}
                                            name="password" value={password} placeholder="Password" />
                                        <div className="input-icon">
                                            <img alt="" src="images/lock.png" />
                                        </div>
                                        <div style={{ color: "red" }}>{errors.password}</div>

                                    </div>
                                    <div className="form-group">
                                        <div className="forgot-pwd">
                                        <NavLink to="/ForgotPassword" >
                                                Forgot Password ? 
                                        </NavLink>

                                        </div>
                                    </div>
 
                                    <div className="form-group">
                                    <div className="forgot-pwd">

                                         <NavLink to="/resendVerificatonLink" >
                                                  Resend Email Verification Link 
                                        </NavLink>
                                        </div>

                                     </div>

                                    <div className="form-group">
                                        <div className="login-btn">
                                            <button type="submit">Login</button>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="agree-site-rule">
                                        <a href={hrefValue} style={{cursor:"auto"}}>By Logging In, I Agree to All Terms of Use </a>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="agree-site-rule">

                                            <NavLink to="/Register" >
                                                I am new User/Doctor
                                        </NavLink>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="footer-login">
                            <ul>
                                <li> <a href="https://ferndaleroad.com/about-us/" rel="noopener noreferrer" target="_blank" > About Us</a></li>
                                <li><NavLink to="/Contact"  > Contact and Support</NavLink></li>
                                <li><NavLink to="/FaqPage"  >FAQ</NavLink></li>
                               
                                <li><NavLink to="/PrivacyPage">Privacy Policy</NavLink></li>
                            </ul>
                        </div>


                    </div>

                </div>
               
            </React.Fragment>
        )
    }
}
const mapStateToProps = state => ({
    forgotPasswordStatus: state.commonReducer.forgotPasswordStatus,
    loginDetails: state.commonReducer.loginDetails,
    loginStatus: state.commonReducer.loginStatus,
    profileDetails: state.commonReducer.profileDetails,
    isLoading: state.commonReducer.isLoading,
    error:state.commonReducer.error,
    sessionExpireStatus : state.commonReducer.sessionExpireStatus

});

const mapDispatchToProps = dispatch => ({
    LoginService: (payLoad, email) => dispatch(LoginService(payLoad, email)),
    getByLocation: () => dispatch(getByLocation()),
    logoutUser: () => dispatch(logoutUser()),
    sessionExpireFalseStatus: () => dispatch(sessionExpireFalseStatus()),
    ForgotPasswordService: payLoad => dispatch(ForgotPasswordService(payLoad))


    
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Login);

